import { Button, Div} from "trunx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { useLocaleContext } from "../contexts/LocaleContext";

export const LangSelect = () => {
  const { setLang, toggleLang, lang } = useLocaleContext();

  const flip = lang === "en" ? "fa-rotate-180" : "";

  return (
    <Div bulma={["level", "is-flex-direction-row"]}>
      <Div bulma="level-left">
        <Button className="is-ghost" onClick={() => setLang("en")}>
          EN
        </Button>
      </Div>
      <Div bulma="level-item">
        <FontAwesomeIcon className={flip} icon={faToggleOn} onClick={toggleLang} />
      </Div>
      <Div bulma="level-right">
        <Button className="is-ghost" onClick={() => setLang("es")}>
          ES
        </Button>
      </Div>
    </Div>
  );
};
